import { z } from 'zod';

import { LanguageEnum, LevelEnum, QuizQuestionEnum } from '../../enums';
import { languageEnumValidator, levelEnumValidator } from '../../validators';

export const GenerateQuizFromWordsSchema = z.object({
  types: z
    .array(z.nativeEnum(QuizQuestionEnum))
    .min(1, 'At least one quiz type must be provided.'),
  words: z
    .array(z.string().min(1))
    .min(1, 'At least one word must be provided.'),
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  level: levelEnumValidator.optional().default(LevelEnum.A1),
});

export type IGenerateQuizFromWordsDto = z.infer<
  typeof GenerateQuizFromWordsSchema
>;
